// src/hooks/useChapterContent.ts
import { useState, useEffect } from 'react';
import { getChapterContent, getChapterMetadata } from '../utils/contentLoader';
import type { Chapter } from '../types/book';

export function useChapterContent() {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentChapter, setCurrentChapter] = useState<number>(1);
  const [chapterContent, setChapterContent] = useState<Chapter | undefined>();
  const [pageContent, setPageContent] = useState<string[]>([]);

  useEffect(() => {
    const loadChapter = async () => {
      const metadata = await getChapterMetadata(currentChapter);
      const content = await getChapterContent(currentChapter, currentPage);
      setChapterContent(metadata);
      setPageContent(content || []);
    };
    loadChapter();
  }, [currentChapter, currentPage]);

  return {
    chapterContent,
    pageContent,
    currentPage,
    currentChapter,
    setCurrentPage,
    setCurrentChapter
  };
}
